import api from '../utils/api';

// Backend: routers/roles.py — the fine-grained RBAC admin surface
// (models/rbac.py). Additive to the existing role-based staff management
// in SettingsPage; see AuthContext.js's `permissions`/`can()` for how the
// codes returned here reach UI gating.
const rolesService = {
  listPermissionCatalog: async () => {
    try {
      return await api.get('/api/roles/permissions');
    } catch (error) {
      console.error('Error fetching permission catalog:', error);
      throw error;
    }
  },
  listRoles: async () => {
    try {
      return await api.get('/api/roles');
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  },
  createRole: async (data) => {
    try {
      return await api.post('/api/roles', data);
    } catch (error) {
      console.error('Error creating role:', error);
      throw error;
    }
  },
  updateRole: async (roleId, data) => {
    try {
      return await api.put(`/api/roles/${roleId}`, data);
    } catch (error) {
      console.error('Error updating role:', error);
      throw error;
    }
  },
  deleteRole: async (roleId) => {
    try {
      return await api.delete(`/api/roles/${roleId}`);
    } catch (error) {
      console.error('Error deleting role:', error);
      throw error;
    }
  },
  cloneRole: async (roleId, name) => {
    try {
      return await api.post(`/api/roles/clone/${roleId}`, { name });
    } catch (error) {
      console.error('Error cloning role:', error);
      throw error;
    }
  },
  assignRoleToUser: async (userId, roleId) => {
    try {
      return await api.post(`/api/roles/assign/${userId}`, { role_id: roleId });
    } catch (error) {
      console.error('Error assigning role to user:', error);
      throw error;
    }
  },
};

export default rolesService;
